import React, { useEffect, useMemo, useRef, useState } from 'react'
import { TextField, Grid, Typography, Card, Box, Stack, CircularProgress, FormHelperText, Icon, Badge, Checkbox, FormControlLabel, FormGroup, FormControl, Accordion, AccordionDetails, AccordionSummary, Switch } from '@mui/material';
import MDButton from 'components/MDButton';
import defaultImage from 'assets/images/placeholder-image.png';
import CommonQuillEditor from 'common/editor';
import { grey } from '@mui/material/colors';
import MDInput from 'components/MDInput';
import { useSelector } from 'react-redux';
import { createStaticPage, deleteLegal, getStaticLegal, openSnackbar, updateStaticPage, uploadImage } from '../../redux/slices/common';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getData } from 'utilities/common';
import DeleteIcon from 'common/customIcons/delete';
import { careerValidation } from 'validations/carrerValidation';
import { closeCustomModalDialog, openCustomModalDialog } from '../../redux/slices/modalSlice';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { slugRegexwithunderScor } from 'utilities/common';

const initialState = {
  'faq': {
    "status": true,
    "section": [
    ]
  },
  "status": true,
  "sectionType": "career_template",
  "headerSection": {
    "section": {
      "description": "",
      "url": "",
      "cta": ""
    },
    "status": true,
    "pageTitle": ""
  },
  "brandStorySection": {
    "pageTitle": "",
    "status": true,
    "section": {
      "title": "",
      "description": "",
      "image": {
        "url": "",
        "title": "",
        "description": "",
        "alt": ""
      },
    }
  },
  "customerExperienceSection": {
    "pageTitle": "",
    "status": true,
    "section": [
      {
        "title": "",
        "description": "",
        // "imageUrl": ""
        "image": {
          "url": "",
          "title": "",
          "description": "",
          "alt": ""
        },
      }
    ]
  },
  "testimonialsSection": {
    "pageTitle": "",
    "status": true,
    "members": [
      {
        "name": "",
        "role": "",
        // "imageUrl": "",
        "description": "",
        "image": {
          "url": "",
          "title": "",
          "description": "",
          "alt": ""
        },
      }
    ]
  },
  "jobOpeningsSection": {
    "pageTitle": "",
    "status": true,
    "link": "",
    "section": [
      {
        "title": "",
        "description": "",
        // "imageUrl": "",
        "url": "",
        "cta": "",
        "image": {
          "url": "",
          "title": "",
          "description": "",
          "alt": ""
        },
      }
    ]
  },
  // "platformAvailability": {
  //   "hyperwolf": true,
  //   "hemp": true,
  //   "stilo": true,
  //   "all": false
  // },
  "displaySettings": {
    "hamburgerMenu": true,
    "footer": true
  },
  "metaProperties": {
    "title": "",
    "description": "",
  },
}

const CareerPageEdit = ({ legalId, dataProps, fullRoleTabSlug }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { isUploading = false, isLoading = false } = useSelector((state => state.common));
  const [errors, setErrors] = useState({});
  const uploadedImageRef = useRef();
  const user = getData('login-user-info')
  const parseUser = JSON.parse(user)

  const [formData, setFormData] = useState({ ...initialState, createdBy: parseUser?.name });
  const [searchParams, setSearchParams] = useSearchParams();
  const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);
  const fullRoleTabHeading = useMemo(() => searchParams.get('heading'), [searchParams]);
  const pageExist = useMemo(() => searchParams.get('pageExist'), [searchParams]);
  const [islegalSlugData, setIslegalSlugData] = useState(false)
  const [notSlug, setNotSlug] = useState(false)

  const uploadThumbnailImage = {
    borderRadius: '20px',
    width: '260px',
    height: '260px',
    objectFit: 'cover',
    boxShadow: '0 0 1px rgb(0 0 0 / 20%)'
  };

  const badgeCircularProgressIcon = {
    backgroundColor: '#fff',
    borderRadius: 10,
    p: .5,
    mr: 14,
    mt: 14
  };

  const checkboxGroup = {
    backgroundColor: "#F2F3F7",
    borderRadius: "6px",
    px: 2.5,
    py: 1,
    flexDirection: "row",
    columnGap: 3
  };

  // ************************************************** Image Upload **************************************************
  const productImageUploadHandler = async (e, imageType) => {
    if (isUploading) return;
    uploadedImageRef.current = imageType;
    if (e.target.files.length) {
      const file = e.target.files[0];
      const body = new FormData();
      body.append('filePath', file);
      dispatch(uploadImage(body)).unwrap().then((res => {
        const data = {
          alt: "",
          title: file?.name,
          description: "",
          url: res.fileUrl

        }
        handleModalImage('brandStorySection', data)
        setFormData((prevData) => ({
          ...prevData,
          brandStorySection: {
            ...prevData.brandStorySection,
            section: {
              ...prevData.brandStorySection.section,
              image: {
                url: res.fileUrl, // Dynamically set the image URL
                title: file?.name, // Use file name as the title
                description: "", // Example description
                alt: ""
              },
            },
          },
        }));
      }));
    }
  };

  // ************************************************** Submit Handler **************************************************

  const isEmptyObject = (obj) => {
    return obj && Object.keys(obj).length === 0;
  };

  const isBlankError = (errors) => {
    return (
      isEmptyObject(errors.headerSection.section) &&
      errors.headerSection.pageTitle === "" && // Check empty string

      isEmptyObject(errors.brandStorySection.section) &&
      errors.brandStorySection.pageTitle === "" && // Check empty string

      (Array.isArray(errors.faq.section) && errors.faq.section.every(isEmptyObject)) &&

      (Array.isArray(errors.customerExperienceSection.section) && errors.customerExperienceSection.section.every(isEmptyObject)) &&
      errors.customerExperienceSection.pageTitle === "" && // Check empty string

      (Array.isArray(errors.jobOpeningsSection.section) && errors.jobOpeningsSection.section.every
        (isEmptyObject)) &&
      errors.jobOpeningsSection.pageTitle === "" && // Check empty string
      errors.jobOpeningsSection.link === "" && // Check empty string


      (Array.isArray(errors.testimonialsSection.members) && errors.testimonialsSection.members.every
        (isEmptyObject)) &&
      errors.testimonialsSection.pageTitle === "" && // Check empty string

      // isEmptyObject(errors.metaProperties) &&
      (!errors.platformAvailability || isEmptyObject(errors.platformAvailability)) &&
      (!errors.displaySettings || isEmptyObject(errors.displaySettings))
    );
  };

  //  get page heading
  useEffect(() => {
    if (!fullRoleTabSlug) {
      setFormData((prev) => ({
        prev,
        ...prev,
        heading: fullRoleTabHeading
      }))
    }
  }, [fullRoleTabHeading])

  const handleSubmit = (e) => {

    e.preventDefault();
    if (!fullRoleTabHeading) {
      showError('Save aborted. Please check your inputs for errors.', 'error');
      return;
    }
    if (pageExist === 'yes') {
      showError('Page Already Exist.', 'error');
      return
    }
    const { errors, isValid } = careerValidation(formData);
    if (!isValid && !isBlankError(errors)) {
      showError('Save aborted. Please check your inputs for errors.', 'error');
      setErrors(errors);
      return;
    }
    setErrors({});
    const updatedValue = {
      ...formData, status: dataProps?.status, "sectionType": "career_template",
    }
    if (!islegalSlugData) {
      delete updatedValue.slug;
      // delete updatedValue?.metaProperties?.canonical;      
    }
    delete updatedValue.legalSlugArray
    if (updatedValue?.metaProperties && typeof updatedValue.metaProperties === 'object') {
      updatedValue.metaProperties = Object.fromEntries(
        Object.entries(updatedValue.metaProperties).filter(([key]) => key !== 'canonical')
      );
    }

    if (fullRoleTabSlug) {
      dispatch(updateStaticPage({ data: updatedValue, id: fullRoleTabHeading, platform: fullRoleTab })).unwrap().then((res) => {
        showError(res?.message, 'success');
        navigate('/manages/static');
      }).catch((err) => {
        showError(err?.message, 'error');
      });
    } else {
      // delete formData.prev;
      const cleanedFormData = {
        ...formData,
        heading: formData.heading.trimEnd(), // Trims only the end spaces
      };
    
      delete cleanedFormData.prev; // Remove 'prev' if it exists
      dispatch(createStaticPage(cleanedFormData)).unwrap().then((res) => {

      // dispatch(createStaticPage(formData)).unwrap().then((res) => {
        showError(res?.message, 'success');
        navigate('/manages/static');
      }).catch((err) => {
        showError(err?.message, 'error');
      });
    }
  }

  const showError = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  // ************************************************** TOPIC section for testimonialsSection && customerExperienceSection**************************************************

  const addBanner = (type) => {
    if (type === 'customerExperienceSection') {

      setFormData((prev) => ({
        ...prev,
        customerExperienceSection: {
          ...prev.customerExperienceSection,
          section: [
            ...prev.customerExperienceSection.section,
            {
              title: '',
              description: '',
              imageUrl: '',
            },
          ],
        },
      }));
    }
    else if (type === `jobOpeningsSection`) {
      setFormData((prev) => ({
        ...prev,
        jobOpeningsSection: {
          ...prev.jobOpeningsSection,
          section: [
            ...prev.jobOpeningsSection.section,
            {
              title: '',
              description: '',
              imageUrl: '',
              url: '',
              cta: ''
            },
          ],
        },
      }));
    }
    else {
      setFormData((prev) => ({
        ...prev,
        testimonialsSection: {
          ...prev.testimonialsSection,
          members: [
            ...prev.testimonialsSection.members,
            {
              name: '',
              role: '',
              description: '',
              imageUrl: '',
            },
          ],
        },
      }));
    }
  };
  const updateBannerField = (index, key, value, sectionType, fileName = "") => {
    setFormData((prev) => {
      const updatedFormData = { ...prev };

      // Function to update the section based on its type
      const updateSection = (sectionKey, sectionArrayKey) => {
        const updatedSections = [...(prev[sectionKey]?.[sectionArrayKey] || [])];

        if (!updatedSections[index]) return; // Ensure the section exists before updating

        if (key === "imageUrl") {
          updatedSections[index] = {
            ...updatedSections[index],
            image: {
              url: value, // Update image URL
              title: fileName || updatedSections[index]?.image?.title || "", // Set title from fileName
              alt: updatedSections[index]?.image?.alt || "",
              description: updatedSections[index]?.image?.description || "",
            },
          };
        } else {
          updatedSections[index] = { ...updatedSections[index], [key]: value };
        }

        updatedFormData[sectionKey] = {
          ...prev[sectionKey],
          [sectionArrayKey]: updatedSections,
        };
      };

      // Check section type and update accordingly
      if (sectionType === "customerExperienceSection" && prev.customerExperienceSection?.section) {
        updateSection("customerExperienceSection", "section");
      } else if (sectionType === "jobOpeningsSection" && prev.jobOpeningsSection?.section) {
        updateSection("jobOpeningsSection", "section");
      } else if (sectionType === "testimonialsSection" && prev.testimonialsSection?.members) {
        updateSection("testimonialsSection", "members");
      }

      return updatedFormData;
    });
  };

  const handleDeleteBanner = (index, sectionType) => {
    if (sectionType === 'customerExperienceSection') {
      if (formData.customerExperienceSection.section.length) {
        const updatedBanners = formData.customerExperienceSection.section.filter((_, i) => i !== index);
        setFormData((prev) => ({
          ...prev,
          customerExperienceSection: {
            ...prev.customerExperienceSection,
            section: updatedBanners,
          },
        }));
      }
    }
    else if (sectionType === 'jobOpeningsSection') {
      if (formData.jobOpeningsSection.section.length) {
        const updatedBanners = formData.jobOpeningsSection.section.filter((_, i) => i !== index);
        setFormData((prev) => ({
          ...prev,
          jobOpeningsSection: {
            ...prev.jobOpeningsSection,
            section: updatedBanners,
          },
        }));
      }
    }
    else {
      if (formData.testimonialsSection.members.length) {
        const updatedBanners = formData.testimonialsSection.members.filter((_, i) => i !== index);
        setFormData((prev) => ({
          ...prev,
          testimonialsSection: {
            ...prev.testimonialsSection,
            members: updatedBanners,
          },
        }));
      }
    }
  };

  const handleImageUpload = (e, index, sectionType) => {

    const file = e.target.files[0];
    uploadedImageRef.current = sectionType + index;
    if (file) {
      const formData = new FormData();
      formData.append("filePath", file);

      // Dispatch the Redux action to upload the image
      dispatch(uploadImage(formData))
        .unwrap()
        .then((res) => {
          const data = {
            alt: "",
            title: file?.name,
            description: "",
            url: res.fileUrl

          }
          if (sectionType === 'testimonialsSection') {
            handleModalImage(sectionType, data, index, 'members')
          }
          else {
            handleModalImage(sectionType, data, index)

          }
          if (res?.fileUrl) {
            updateBannerField(index, "imageUrl", res.fileUrl, sectionType, file?.name); // Set uploaded image URL in formData
          }
        })
        .catch((error) => {
        });
    }
  };

  // ************************************************** Check Box Handle **************************************************

  const handleCheckboxChange = (platform) => {
    setFormData((prev) => {
      const updatedPlatforms = { ...prev.platformAvailability };
      if (platform === 'all') {
        const allChecked = !updatedPlatforms.all;
        Object.keys(updatedPlatforms).forEach((key) => {
          updatedPlatforms[key] = allChecked;
        });
      } else {
        updatedPlatforms[platform] = !updatedPlatforms[platform];

        if (!updatedPlatforms[platform]) {
          updatedPlatforms.all = false;
        } else {
          const allSelected = Object.keys(updatedPlatforms)
            .filter((key) => key !== 'all')
            .every((key) => updatedPlatforms[key]);
          updatedPlatforms.all = allSelected;
        }
      }
      return { ...prev, platformAvailability: updatedPlatforms };
    });
  };

  const handleShowOnChange = (field) => {
    setFormData((prev) => ({
      ...prev,
      displaySettings: {
        ...prev.displaySettings,
        [field]: !prev.displaySettings[field],
      },
    }));
  };
  // *************************************************** FAQ********************************************************

  const handleRemoveFAQ = (faQIdx) => {
    let FAQArray = [...(formData?.faq?.section || [])];
    FAQArray = FAQArray.filter((faq, _idx) => _idx !== faQIdx);
    setFormData({
      ...formData,
      faq: {
        ...formData?.faq,
        section: FAQArray
      }
    });
  };

  const addFAQHandler = () => {
    let newFAQ = [...(formData?.faq?.section || [])];
    let faqItem = {
      question: '',
      answer: ''
    };
    newFAQ.push(faqItem);
    setFormData({
      ...formData,
      faq: {
        ...formData?.faq,
        section: newFAQ
      }
    });
  };

  const handleChangeFAQ = (value, fieldType, idx) => {
    let FAQArray = [...(formData?.faq?.section || [])];
    if (FAQArray[idx]) {
      FAQArray[idx] = {
        ...FAQArray[idx],
        [fieldType]: value
      };
      setFormData({
        ...formData,
        faq: {
          ...formData?.faq,
          section: FAQArray
        }
      });
    }
  };


  // ************************************************** Get Data **************************************************
  useEffect(() => {
    if (fullRoleTabSlug) {
      dispatch(getStaticLegal({ id: fullRoleTabHeading, platform: fullRoleTab })).unwrap().then((res) => {
        setNotSlug(true)
        setFormData(prev => ({
          ...prev,
          ...res?.legalDetails,
          heading: fullRoleTabHeading ? fullRoleTabHeading : res?.legalDetails?.heading,
        }));
      }).catch((err) => {
        setNotSlug(false)
        setFormData({
          ...initialState,
          createdBy: parseUser?.name || "",
          heading: fullRoleTabHeading ? fullRoleTabHeading : '',
          platformAvailability: {
            hyperwolf: fullRoleTab === 'hyperwolf' ? true : false,
            hemp: fullRoleTab === 'hemp' ? true : false,
            stilo: fullRoleTab === 'stilo' ? true : false,
          },

        });
      });
    } else {
      setFormData(prev => ({
        ...initialState,
        createdBy: parseUser?.name,
        heading: fullRoleTabHeading ? fullRoleTabHeading : '',
        platformAvailability: {
          hyperwolf: fullRoleTab === 'hyperwolf' ? true : false,
          hemp: fullRoleTab === 'hemp' ? true : false,
          stilo: fullRoleTab === 'stilo' ? true : false,
        },
      }));

    }
  }, [fullRoleTabSlug, fullRoleTab])


  // **************************************************Media modal handle **************************************************
  const handleModalImage = (type, data, index, memberSection) => {
    dispatch(openCustomModalDialog({
      modal: 'IMAGE_MODAL_SEO',
      modalData: {
        imageContent: type, data, index, memberSection, fileMediaHandler
      }
    }))
  }

  const fileMediaHandler = (mediaData, imageContent, index, memberSection) => {

    if (index === undefined) {
      setFormData((prevData) => ({
        ...prevData,
        [imageContent]: {
          ...prevData[imageContent],
          section: {
            ...prevData[imageContent].section,
            image: mediaData,
          },
        },
      }));
    }
    else if (memberSection === 'members') {
      setFormData((prevData) => ({
        ...prevData,
        [imageContent]: {
          ...prevData[imageContent],
          members: index !== undefined
            ? prevData[imageContent].members.map((item, idx) =>
              idx === index ? { ...item, image: mediaData } : item
            )
            : prevData[imageContent].members, // No change if index is not provided
        },
      }));
    }
    else {
      setFormData((prevData) => ({
        ...prevData,
        [imageContent]: {
          ...prevData[imageContent],
          section: index !== undefined
            ? prevData[imageContent].section.map((item, idx) =>
              idx === index ? { ...item, image: mediaData } : item
            )
            : prevData[imageContent].section, // No change if index is not provided
        },
      }));
    }
  };

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleChangeSlug = (e) => {
    const value = e.target.value;
    setIslegalSlugData(true);
    setFormData((prev => ({
      ...prev,
      slug: slugRegexwithunderScor(value)
    })))
  };

  const deleteHandler = (deleteId) => {
    dispatch(deleteLegal({ slug: deleteId, platform: fullRoleTab }))
      .unwrap()
      .then((res) => {
        showError(res?.message, "success");
        dispatch(closeCustomModalDialog());
        navigate('/manages/static');
      })
      .catch((err) => {
        showError(err?.message, "error");
      });
  };

  return (
    <Box p={4} pt={2} className="static-pages-container">

      {/********************** Select Platform/Show On **********************/}
      <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
        <Grid container spacing={3}>
          {/* {
            !legalId &&
            <Grid item xs={12}>
              <Typography variant='h5' fontWeight="semibold" mb={2}>Select Platform</Typography>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControl sx={{ width: "100%" }}>
                    <FormGroup className='radio-colors' sx={checkboxGroup}>
                      <FormControlLabel control={<Checkbox checked={formData?.platformAvailability?.all} onChange={() => handleCheckboxChange('all')} />}
                        label={<>All</>}
                      />
                      <FormControlLabel control={<Checkbox checked={formData?.platformAvailability?.hyperwolf} onChange={() => handleCheckboxChange('hyperwolf')} />}
                        label={<>Hyperwolf</>}
                      />
                      <FormControlLabel control={<Checkbox checked={formData?.platformAvailability?.hemp} onChange={() => handleCheckboxChange('hemp')} />}
                        label={<>Hemp</>}
                      />
                      <FormControlLabel control={<Checkbox checked={formData?.platformAvailability?.stilo} onChange={() => handleCheckboxChange('stilo')} />}
                        label={<>Stilo</>} />
                    </FormGroup>
                  </FormControl>
                  {Boolean(errors?.platformAvailability) && <FormHelperText error>{errors?.platformAvailability}</FormHelperText>}
                </Grid>
              </Grid>
            </Grid>
          } */}

          <Grid item xs={12}>
            {
              fullRoleTabSlug &&
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <div className="w-100 mb-4">
                    <Typography variant='h5' fontWeight="semibold" mb={2}>Page Name</Typography>
                    <TextField
                      label='Page Name'
                      fullWidth
                      variant='outlined'
                      name='heading'
                      value={formData?.heading || ''}
                      className='form-input'
                      disabled={true}
                    />
                  </div>
                </Grid>
                {
                  notSlug &&
                  <Grid item xs={12} md={4}>
                    <div className="w-100 mb-4">
                      <Typography variant='h5' fontWeight="semibold" mb={2}>Page Slug</Typography>
                      <TextField
                        label='Page Slug'
                        fullWidth
                        variant='outlined'
                        name='slug'
                        value={formData?.slug || ''}
                        onChange={handleChangeSlug}

                        className='form-input'
                      />
                    </div>
                  </Grid>
                }
              </Grid>
            }
            <Typography variant='h5' fontWeight="semibold" mb={2}>Visible On</Typography>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <FormGroup className='radio-colors' sx={checkboxGroup}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData?.displaySettings?.hamburgerMenu}
                          onChange={() => handleShowOnChange('hamburgerMenu')}
                        />
                      }
                      label="Hamburger Menu"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData?.displaySettings?.footer}
                          onChange={() => handleShowOnChange('footer')}
                        />
                      }
                      label="Footer"
                    />
                  </FormGroup>
                </FormControl>
                {Boolean(errors?.displaySettings) && <FormHelperText error>{errors?.displaySettings}</FormHelperText>}

              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </Card>

      {/********************** Meta Tags **********************/}
      <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
        <Typography variant='h5' fontWeight="semibold" mb={2}>Meta Properties</Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <TextField
              label="Meta Title"
              className="form-input"
              fullWidth
              placeholder="Meta Title"
              value={formData?.metaProperties?.title}
              onChange={(e) => setFormData((prev) => ({ ...prev, metaProperties: { ...prev?.metaProperties, title: e.target.value } }))}
              error={Boolean(errors?.metaProperties?.title)}
              helperText={errors?.metaProperties?.title}
            />
            <span className='drag_drop'>
              Character Count: {formData?.metaProperties?.title?.length || 0} <span>(Recommended Characters: 60)</span>
            </span>
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              label="Meta Description"
              className="form-input"
              fullWidth
              placeholder="Meta Description"
              value={formData?.metaProperties?.description}
              onChange={(e) => setFormData((prev) => ({ ...prev, metaProperties: { ...prev?.metaProperties, description: e.target.value } }))}
              error={Boolean(errors?.metaProperties?.description)}
              helperText={errors?.metaProperties?.description}

            />
            <span className='drag_drop'>
              Character Count: {formData?.metaProperties?.description?.length || 0} <span>(Recommended Characters: 160)</span>
            </span>
          </Grid>
        </Grid>
      </Card>

      {/********************** Top Banner ***********************/}
      <Accordion expanded={expanded === 'header'} onChange={handleChange('header')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panelheading-content"
          id="panelheading-header"
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>Header Section</Typography>
            <FormControlLabel
              onClick={(e) => e.stopPropagation()}
              control={
                <Switch
                  checked={formData?.headerSection?.status}
                  onChange={() => setFormData((prev) => ({ ...prev, headerSection: { ...prev.headerSection, status: !prev.headerSection.status, } }))}
                />
              }
              label={formData?.headerSection?.status ? "Visible" : "Hidden"}
            />
          </Box>
        </AccordionSummary>


        <AccordionDetails>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={12} md={6}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>Page Title(H1)</Typography>
                  <TextField
                    label="Page Title(H1)"
                    className="form-input"
                    fullWidth
                    placeholder="Page Title(H1)"
                    value={formData?.headerSection?.pageTitle}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, headerSection: { ...prev.headerSection, pageTitle: e.target.value }, }))
                    }
                    error={Boolean(errors?.headerSection?.pageTitle)}
                    helperText={errors?.headerSection?.pageTitle}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                  <CommonQuillEditor
                    allowHeading={false}
                    value={formData?.headerSection?.section?.description || ''}
                    onChange={(value) => setFormData((prev) => ({
                      ...prev,
                      headerSection: { ...prev?.headerSection, section: { ...prev?.headerSection?.section, description: value, }, },
                    }))
                    }
                  />
                  {Boolean(errors?.headerSection?.section?.description) && <FormHelperText error>{errors?.headerSection?.section?.description}</FormHelperText>}
                </Grid>

                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>CTA</Typography>
                      <TextField
                        label="CTA"
                        className="form-input"
                        fullWidth
                        placeholder="CTA"
                        value={formData?.headerSection?.section?.cta}
                        onChange={(e) => setFormData((prev) => ({
                          ...prev,
                          headerSection: { ...prev?.headerSection, section: { ...prev?.headerSection?.section, cta: e.target.value } },
                        }))
                        }
                        error={Boolean(errors?.headerSection?.section?.cta)}
                        helperText={errors?.headerSection?.section?.cta}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>CTA Link</Typography>
                      <TextField
                        label="CTA Link"
                        className="form-input"
                        fullWidth
                        placeholder="CTA Link"
                        value={formData?.headerSection?.section?.url}
                        onChange={(e) => setFormData((prev) => ({
                          ...prev,
                          headerSection: { ...prev?.headerSection, section: { ...prev?.headerSection?.section, url: e.target.value } },
                        }))
                        }
                        error={Boolean(errors?.headerSection?.section?.url)}
                        helperText={errors?.headerSection?.section?.url}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/********************** Why HyperWolf Section : brandStorySection ***********************/}
      <Accordion expanded={expanded === 'heroBanner'} onChange={handleChange('heroBanner')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panelherobanner-content"
          id="panelherobanner-header"
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>Hero Banner</Typography>
            <FormControlLabel
              onClick={(e) => e.stopPropagation()}
              control={
                <Switch
                  checked={formData?.brandStorySection?.status}
                  onChange={() => setFormData((prev) => ({ ...prev, brandStorySection: { ...prev.brandStorySection, status: !prev.brandStorySection.status, } }))}
                />
              }
              label={formData?.brandStorySection?.status ? "Visible" : "Hidden"}
            />
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <div className="st-block-sec full-img-sec">
            <div className="st-img-sec">
              <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Image</Typography>
              <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} className="image-sec">
                <Badge
                  overlap='circular'
                  anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                  badgeContent={
                    isUploading && uploadedImageRef.current === 'brandStorySection.section.imageUrl' ? <CircularProgress size={32} color='primary' sx={badgeCircularProgressIcon} /> : ''
                  }
                >
                  {
                    formData?.brandStorySection?.section?.image?.url ?
                      <img style={uploadThumbnailImage} key={formData?.brandStorySection?.section?.image?.url} onClick={() => handleModalImage("brandStorySection", formData?.brandStorySection?.section?.image)} src={formData?.brandStorySection?.section?.image?.url || defaultImage} alt='documentId' />
                      :
                      <>
                        <label htmlFor='brandStorySectionImage-input' className='add-change-image'>
                          <MDButton
                            type='button'
                            variant='outlined'
                            color='secondary'
                            component='span'
                            disabled={isUploading}
                          >
                            <div className='add-change-img-sec'>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <g clipPath="url(#clip0_13676_49992)">
                                  <path d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z" fill="#2E2E3A" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_13676_49992">
                                    <rect width="24" height="25" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                              <h5>Add Image</h5>
                              <p>736x624</p>
                            </div>
                          </MDButton>
                        </label>
                      </>
                  }

                </Badge>
                {formData?.brandStorySection?.section?.image?.url &&

                  <label htmlFor='brandStorySectionImage-input' className='upload-change-image'>
                    <MDButton
                      type='button'
                      variant='outlined'
                      color='secondary'
                      component='span'
                      disabled={isUploading}
                    >
                      <div className='add-change-img-sec'>
                        <p>Change File(736x624)</p>
                      </div>
                    </MDButton>
                  </label>
                }
                <MDInput
                  id='brandStorySectionImage-input'
                  type='file'
                  name='brandStorySectionImage'
                  onChange={(e) => productImageUploadHandler(e, 'brandStorySection.section.imageUrl')}
                  fullWidth
                  disabled={isUploading}
                  style={{ display: 'none' }}
                />
                {Boolean(errors?.brandStorySection?.section?.image?.url) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.brandStorySection?.section?.image?.url}</FormHelperText>}
              </Stack>
            </div>
            <div className="st-contents-sec">
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>Section Title (H3)</Typography>
                  <TextField
                    label="Section Title(H3)"
                    className="form-input"
                    fullWidth
                    placeholder="Section Title(H3)"
                    value={formData?.brandStorySection?.pageTitle}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, brandStorySection: { ...prev.brandStorySection, pageTitle: e.target.value }, }))
                    }
                    error={Boolean(errors?.brandStorySection?.pageTitle)}
                    helperText={errors?.brandStorySection?.pageTitle}
                  />
                  <span className='drag_drop'>
                    Character Count: {formData?.brandStorySection?.pageTitle?.length || 0} <span>(Max: 60)</span>
                  </span>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                  <CommonQuillEditor
                    allowHeading={false}
                    value={formData?.brandStorySection?.section?.description || ''}
                    onChange={(value) => setFormData((prev) => ({
                      ...prev,
                      brandStorySection: { ...prev?.brandStorySection, section: { ...prev?.brandStorySection?.section, description: value, }, },
                    }))
                    }
                  />
                  {Boolean(errors?.brandStorySection?.section?.description) && <FormHelperText error>{errors?.brandStorySection?.section?.description}</FormHelperText>}
                  <span className='drag_drop'>
                    Character Count: {formData?.brandStorySection?.section?.description?.length || 0} <span>(Max: 950)</span>
                  </span>
                </Grid>
              </Grid>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>

      {/********************** CustomerExperienceSection Section **********************/}
      <Accordion expanded={expanded === 'alternatingContent'} onChange={handleChange('alternatingContent')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panelalternating-content"
          id="panelalternating-header"
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>{`Alternating Content Showcase`}</Typography>
            <FormControlLabel
              onClick={(e) => e.stopPropagation()}
              control={
                <Switch
                  checked={formData?.customerExperienceSection?.status}
                  onChange={() => setFormData((prev) => ({ ...prev, customerExperienceSection: { ...prev.customerExperienceSection, status: !prev.customerExperienceSection.status, } }))}
                />
              }
              label={formData?.customerExperienceSection?.status ? "Visible" : "Hidden"}
            />
          </Box>
        </AccordionSummary>

        <AccordionDetails>
          <Grid container spacing={3} mb={4} className="full-img-sec">
            <Grid item xs={12} md={4}>
              <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Section Title(H2)</Typography>
              <TextField
                label="Section Title(H2)"
                className="form-input"
                fullWidth
                placeholder="Section Title(H2)"
                value={formData?.customerExperienceSection?.pageTitle}
                onChange={(e) => setFormData((prev) => ({ ...prev, customerExperienceSection: { ...prev.customerExperienceSection, pageTitle: e.target.value }, }))}
                error={Boolean(errors?.customerExperienceSection?.pageTitle)}
                helperText={errors?.customerExperienceSection?.pageTitle}

              />
            </Grid>
          </Grid>

          {/* Render All Banners Dynamically */}
          <div className="alernative-sections">
            {formData?.customerExperienceSection?.section?.map((banner, index) => (
              <Card sx={{ p: 3, mb: 2, borderRadius: 2.5, boxShadow: 'none' }} key={index}
                style={{
                  borderRadius: "18px",
                  border: "1px solid #F1F1F1"
                }}
              >
                <Box display="flex" alignItems="center" justifyContent="end">
                  {/* {index > 0 && ( */}
                  <MDButton
                    sx={{ minWidth: 'auto', p: 0 }}
                    size="small"
                    variant='text'
                    onClick={() => handleDeleteBanner(index, 'customerExperienceSection')}
                    color="error"
                  >
                    <DeleteIcon width="1rem" height="1rem" />
                  </MDButton>
                  {/* )} */}
                </Box>
                <div className="st-block-sec">
                  <div className="st-img-sec">
                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Image {index + 1}</Typography>
                    {/* Image Upload */}
                    <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} className="image-sec">
                      <Badge
                        overlap='circular'
                        anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                        badgeContent={isUploading && uploadedImageRef.current === `customerExperienceSection${index}` ? <CircularProgress size={32} color='primary' /> : ''}
                      >
                        {
                          banner.image?.url ?
                            <img key={banner.image?.url} onClick={() => handleModalImage("customerExperienceSection", banner.image, index)} style={uploadThumbnailImage} src={banner.image?.url || defaultImage} alt='banner' />
                            :
                            <>
                              <label htmlFor={`image-upload-${index}`} className='add-change-image'>
                                <MDButton
                                  type='button'
                                  variant='outlined'
                                  color='secondary'
                                  component='span'
                                  disabled={isUploading}
                                >
                                  <div className='add-change-img-sec'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                      <g clipPath="url(#clip0_13676_49992)">
                                        <path d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z" fill="#2E2E3A" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_13676_49992">
                                          <rect width="24" height="25" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    <h5>Add Image</h5>
                                    <p>590x422</p>
                                  </div>
                                </MDButton>
                              </label>
                            </>
                        }
                      </Badge>
                      {
                        banner.image?.url &&
                        <label htmlFor={`image-upload-${index}`} className='upload-change-image'>
                          <MDButton
                            type='button'
                            variant='outlined'
                            color='secondary'
                            component='span'
                            disabled={isUploading}
                          >
                            <div className='add-change-img-sec'>
                              <p>Change File(590x422)</p>
                            </div>
                          </MDButton>
                        </label>
                      }
                      <MDInput
                        id={`image-upload-${index}`}
                        type='file'
                        name='categoryImage'
                        onChange={(e) => handleImageUpload(e, index, 'customerExperienceSection')}
                        fullWidth
                        disabled={isUploading}
                        style={{ display: 'none' }}
                      />
                      {Boolean(errors?.customerExperienceSection?.section[index]?.image?.url) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.customerExperienceSection?.section[index]?.image?.url}</FormHelperText>}
                    </Stack>
                  </div>
                  <div className="st-contents-sec">
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Title (H3)</Typography>
                        <TextField
                          label="Title (H3)"
                          className="form-input"
                          fullWidth
                          placeholder="Title (H3)"
                          value={banner.title || ''}
                          onChange={(e) => updateBannerField(index, 'title', e.target.value, 'customerExperienceSection')}
                          error={Boolean(errors?.customerExperienceSection?.section[index]?.title)}
                          helperText={errors?.customerExperienceSection?.section[index]?.title}
                        />
                        <span className='drag_drop'>
                          Character Count: {banner.title?.length || 0} <span>(Max: 60)</span>
                        </span>
                      </Grid>

                      <Grid item xs={12}>
                        {/* Description */}
                        <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                        <CommonQuillEditor
                          allowHeading={false}
                          value={banner.description || ''}
                          onChange={(value) => updateBannerField(index, 'description', value, 'customerExperienceSection')}
                        />
                        {Boolean(errors?.customerExperienceSection?.section[index]?.description) && (
                          <FormHelperText error>{errors?.customerExperienceSection?.section[index]?.description}</FormHelperText>
                        )}
                        <span className='drag_drop'>
                          Character Count: {banner.description?.length || 0} <span>(Max: 550)</span>
                        </span>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </Card>
            ))}
          </div>

          {/* Add More Button */}
          <Grid item xs={12}>
            <MDButton type='button' color='primary' size='medium' variant='outlined' sx={{ minWidth: '180px' }} onClick={() => addBanner("customerExperienceSection")}>
              <Icon>add</Icon>&nbsp;Add More
            </MDButton>
          </Grid>

        </AccordionDetails>
      </Accordion>

      {/********************** Employee Testimonial Section **********************/}
      <Accordion expanded={expanded === 'tertimonials'} onChange={handleChange('tertimonials')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="paneltertimonials-content"
          id="paneltertimonials-header"
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant='h4' fontWeight='semibold'>Testimonials</Typography>
            <FormControlLabel
              onClick={(e) => e.stopPropagation()}
              control={
                <Switch
                  checked={formData?.testimonialsSection?.status}
                  onChange={() => setFormData((prev) => ({ ...prev, testimonialsSection: { ...prev.testimonialsSection, status: !prev.testimonialsSection.status, } }))}
                />
              }
              label={formData?.testimonialsSection?.status ? "Visible" : "Hidden"}
            />
          </Box>
        </AccordionSummary>

        <AccordionDetails>
          <Grid container spacing={3} mb={4}>
            <Grid item xs={12} md={6}>
              <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Section Title(H2)</Typography>
              <TextField
                label="Section Title(H2)"
                className="form-input"
                fullWidth
                placeholder="Section Title(H2)"
                value={formData?.testimonialsSection?.pageTitle}
                onChange={(e) => setFormData((prev) => ({ ...prev, testimonialsSection: { ...prev.testimonialsSection, pageTitle: e.target.value }, }))}
                error={Boolean(errors?.testimonialsSection?.pageTitle)}
                helperText={errors?.testimonialsSection?.pageTitle}

              />
            </Grid>
          </Grid>

          {/* Render All Banners Dynamically */}
          <Grid container spacing={3} className="image-sec-100 view-image-sec-100">
            {formData?.testimonialsSection?.members?.map((banner, index) => {
              return (
                <Grid item xs={12} md={6} key={index}>
                  <Card sx={{ p: 3, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}
                    style={{
                      borderRadius: "18px",
                      border: "1px solid #F1F1F1"
                    }}
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={12} display="flex" alignItems="center" justifyContent="end"
                        style={{ minHeight: "56px" }}
                      >
                        {/* {index > 0 && ( */}
                        <MDButton
                          sx={{ gap: 0.5 }}
                          size="small"
                          variant='text'
                          onClick={() => handleDeleteBanner(index, 'testimonialsSection')}
                          color="error"
                        >
                          <DeleteIcon width="1rem" height="1rem" /> Delete
                        </MDButton>
                        {/* )} */}
                      </Grid>

                      <Grid item xs={12} style={{ paddingTop: "0" }}>
                        <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Image</Typography>
                        <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} className="image-sec">
                          <Badge
                            overlap='circular'
                            anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                            badgeContent={isUploading && uploadedImageRef.current === `testimonialsSection${index}` ? <CircularProgress size={32} color='primary' /> : ''}
                          >
                            {
                              banner.image?.url ?
                                <img key={banner.image?.url} onClick={() => handleModalImage("testimonialsSection", banner.image, index, "members")} style={uploadThumbnailImage} src={banner.image?.url || defaultImage} alt='banner' />
                                :
                                <>
                                  <label htmlFor={`testimonialsSection-${index}`} className='add-change-image'>
                                    <MDButton
                                      type='button'
                                      variant='outlined'
                                      color='secondary'
                                      component='span'
                                      disabled={isUploading}
                                    >
                                      <div className='add-change-img-sec'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                          <g clipPath="url(#clip0_13676_49992)">
                                            <path d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z" fill="#2E2E3A" />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_13676_49992">
                                              <rect width="24" height="25" fill="white" />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                        <h5>Add Image</h5>
                                        <p>90x90</p>
                                      </div>
                                    </MDButton>
                                  </label>
                                </>
                            }                  </Badge>
                          {
                            banner.image?.url &&
                            <label htmlFor={`testimonialsSection-${index}`} className='upload-change-image'>
                              <MDButton
                                type='button'
                                variant='outlined'
                                color='secondary'
                                component='span'
                                disabled={isUploading}
                              >
                                <div className='add-change-img-sec'>
                                  <p>Change File(90x90)</p>
                                </div>
                              </MDButton>
                            </label>
                          }
                          <MDInput
                            id={`testimonialsSection-${index}`}
                            type='file'
                            name='categoryImage'
                            onChange={(e) => handleImageUpload(e, index, 'testimonialsSection')}
                            fullWidth
                            disabled={isUploading}
                            style={{ display: 'none' }}
                          />
                          {Boolean(errors?.testimonialsSection?.members[index]?.image?.url) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.testimonialsSection?.members[index]?.image?.url}</FormHelperText>}
                        </Stack>
                      </Grid>

                      <Grid item xs={12}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} md={6}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Employee Name</Typography>
                            <TextField
                              label="Employee Name"
                              className="form-input"
                              fullWidth
                              placeholder="Employee Name"
                              value={banner.name}
                              onChange={(e) => updateBannerField(index, 'name', e.target.value, 'testimonialsSection')}
                              error={Boolean(errors?.testimonialsSection?.members[index]?.name)}
                              helperText={errors?.testimonialsSection?.members[index]?.name}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Employee Role</Typography>
                            <TextField
                              label="Employee Role"
                              className="form-input"
                              fullWidth
                              placeholder="Employee Role"
                              value={banner.role}
                              onChange={(e) => { updateBannerField(index, 'role', e.target.value, 'testimonialsSection') }}
                              error={Boolean(errors?.testimonialsSection?.members[index]?.role)}
                              helperText={errors?.testimonialsSection?.members[index]?.role}
                            />
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12}>
                        {/* Description */}
                        <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                        <CommonQuillEditor
                          allowHeading={false}
                          value={banner.description || ''}
                          onChange={(value) => updateBannerField(index, 'description', value, 'testimonialsSection')}
                        />
                        {Boolean(errors?.testimonialsSection?.members[index]?.description) && (
                          <FormHelperText error>{errors?.testimonialsSection?.members[index]?.description}</FormHelperText>
                        )}

                      </Grid>

                    </Grid>
                  </Card>
                </Grid>
              )
            }
            )}
          </Grid>

          {/* Add More Button */}
          <Grid item xs={12}>
            <MDButton type='button' color='primary' size='medium' variant='outlined' sx={{ minWidth: '180px' }} onClick={() => addBanner("testimonialsSection")}>
              <Icon>add</Icon>&nbsp;Add More
            </MDButton>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/**********************  Available Position **********************/}
      <Accordion expanded={expanded === 'availablePosition'} onChange={handleChange('availablePosition')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panelavailablePosition-content"
          id="panelavailablePosition-header"
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>{`Available Position`}</Typography>
            <FormControlLabel
              onClick={(e) => e.stopPropagation()}
              control={
                <Switch
                  checked={formData?.jobOpeningsSection?.status}
                  onChange={() => setFormData((prev) => ({ ...prev, jobOpeningsSection: { ...prev.jobOpeningsSection, status: !prev.jobOpeningsSection.status, } }))}
                />
              }
              label={formData?.jobOpeningsSection?.status ? "Visible" : "Hidden"}
            />          </Box>
        </AccordionSummary>

        <AccordionDetails>
          <Grid container spacing={3} mb={4}>
            <Grid item xs={12} md={4}>
              <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Section Title(H2)</Typography>
              <TextField
                label="Section Title(H2)"
                className="form-input"
                fullWidth
                placeholder="Section Title(H2)"
                value={formData?.jobOpeningsSection?.pageTitle}
                onChange={(e) => setFormData((prev) => ({ ...prev, jobOpeningsSection: { ...prev.jobOpeningsSection, pageTitle: e.target.value }, }))}
                error={Boolean(errors?.jobOpeningsSection?.pageTitle)}
                helperText={errors?.jobOpeningsSection?.pageTitle}

              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>All Openings Link</Typography>
              <TextField
                label="All Openings Link"
                className="form-input"
                fullWidth
                placeholder="All Openings Link"
                value={formData?.jobOpeningsSection?.link}
                onChange={(e) => setFormData((prev) => ({ ...prev, jobOpeningsSection: { ...prev.jobOpeningsSection, link: e.target.value }, }))}
                error={Boolean(errors?.jobOpeningsSection?.link)}
                helperText={errors?.jobOpeningsSection?.link}

              />
            </Grid>
          </Grid>

          {/* Render All Banners Dynamically */}
          <div className="alernative-sections">
            {formData?.jobOpeningsSection?.section?.map((banner, index) => (
              <Card sx={{ p: 3, mb: 2, borderRadius: 2.5, boxShadow: 'none' }} key={index}
                style={{
                  borderRadius: "18px",
                  border: "1px solid #F1F1F1"
                }}
              >
                <Box display="flex" alignItems="center" justifyContent="end">
                  {/* {index > 0 && ( */}
                  <MDButton
                    sx={{ gap: 0.5 }}
                    size="small"
                    variant='text'
                    onClick={() => handleDeleteBanner(index, 'jobOpeningsSection')}
                    color="error"
                  >
                    <DeleteIcon width="1rem" height="1rem" /> Delete
                  </MDButton>
                  {/* )} */}
                </Box>

                <div className="st-block-sec">
                  <div className="st-img-sec">
                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Image</Typography>
                    <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} className="image-sec">
                      <Badge
                        overlap='circular'
                        anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                        badgeContent={isUploading && uploadedImageRef.current === `jobOpeningsSection${index}` ? <CircularProgress size={32} color='primary' /> : ''}
                      >
                        {
                          banner.image?.url ?
                            <img key={banner.image?.url} onClick={() => handleModalImage("jobOpeningsSection", banner.image, index)} style={uploadThumbnailImage} src={banner.image?.url || defaultImage} alt='banner' />
                            :
                            <>
                              <label htmlFor={`jobOpeningsSection-${index}`} className='add-change-image'>
                                <MDButton
                                  type='button'
                                  variant='outlined'
                                  color='secondary'
                                  component='span'
                                  disabled={isUploading}
                                >
                                  <div className='add-change-img-sec'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                      <g clipPath="url(#clip0_13676_49992)">
                                        <path d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z" fill="#2E2E3A" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_13676_49992">
                                          <rect width="24" height="25" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    <h5>Add Image</h5>
                                    <p>590x422</p>
                                  </div>
                                </MDButton>
                              </label>
                            </>
                          // <img key={banner.image?.url} style={uploadThumbnailImage} src={banner.image?.url || defaultImage} alt='banner' />
                        }
                      </Badge>
                      {
                        banner.image?.url &&
                        <label htmlFor={`jobOpeningsSection-${index}`} className='upload-change-image'>
                          <MDButton
                            type='button'
                            variant='outlined'
                            color='secondary'
                            component='span'
                            disabled={isUploading}
                          >
                            <div className='add-change-img-sec'>
                              <p>Change File(590x422)</p>
                            </div>
                          </MDButton>
                        </label>
                      }
                      <MDInput
                        id={`jobOpeningsSection-${index}`}
                        type='file'
                        name='categoryImage'
                        onChange={(e) => handleImageUpload(e, index, 'jobOpeningsSection')}
                        fullWidth
                        disabled={isUploading}
                        style={{ display: 'none' }}
                      />
                      {Boolean(errors?.jobOpeningsSection?.section[index]?.image?.url) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.jobOpeningsSection?.section[index]?.image?.url}</FormHelperText>}
                    </Stack>
                  </div>

                  <div className="st-contents-sec">
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Position Name (H3)</Typography>
                        <TextField
                          label="Position Name (H3)"
                          className="form-input"
                          fullWidth
                          placeholder="Position Name (H3)"
                          value={banner.title || ''}
                          onChange={(e) => updateBannerField(index, 'title', e.target.value, 'jobOpeningsSection')}
                          error={Boolean(errors?.jobOpeningsSection?.section[index]?.title)}
                          helperText={errors?.jobOpeningsSection?.section[index]?.title}
                        />
                        <span className='drag_drop'>
                          Character Count: {banner.title?.length || 0} <span>(Max: 60)</span>
                        </span>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                        <CommonQuillEditor
                          allowHeading={false}
                          value={banner.description || ''}
                          onChange={(value) => updateBannerField(index, 'description', value, 'jobOpeningsSection')}
                        />
                        {Boolean(errors?.jobOpeningsSection?.section[index]?.description) && (
                          <FormHelperText error>{errors?.jobOpeningsSection?.section[index]?.description}</FormHelperText>
                        )}
                        <span className='drag_drop'>
                          Character Count: {banner.description?.length || 0} <span>(Max: 450)</span>
                        </span>
                      </Grid>

                      <Grid item xs={12}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} md={5}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>CTA</Typography>
                            <TextField
                              label="CTA"
                              className="form-input"
                              fullWidth
                              placeholder="CTA"
                              value={banner.cta || ''}
                              onChange={(e) => updateBannerField(index, 'cta', e.target.value, 'jobOpeningsSection')}
                              error={Boolean(errors?.jobOpeningsSection?.section[index]?.cta)}
                              helperText={errors?.jobOpeningsSection?.section[index]?.cta}
                            />
                          </Grid>
                          <Grid item xs={12} md={5}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>CTA Link</Typography>
                            <TextField
                              label="CTA Link"
                              className="form-input"
                              fullWidth
                              placeholder="CTA Link"
                              value={banner.url || ''}
                              onChange={(e) => updateBannerField(index, 'url', e.target.value, 'jobOpeningsSection')}
                              error={Boolean(errors?.jobOpeningsSection?.section[index]?.url)}
                              helperText={errors?.jobOpeningsSection?.section[index]?.url}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                </div>

              </Card>
            ))}
          </div>

          {/* Add More Button */}
          <Grid item xs={12}>
            <MDButton type='button' color='primary' size='medium' variant='outlined' sx={{ minWidth: '180px' }} onClick={() => addBanner("jobOpeningsSection")}>
              <Icon>add</Icon>&nbsp;Add More
            </MDButton>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/********************** FAQ **********************/}
      <Accordion expanded={expanded === 'faqSection'} onChange={handleChange('faqSection')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panelfaqSection-content"
          id="panelfaqSection-header"
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>FAQs</Typography>
            <FormControlLabel
              onClick={(e) => e.stopPropagation()}
              control={
                <Switch
                  checked={formData?.faq?.status}
                  onChange={() => setFormData((prev) => ({ ...prev, faq: { ...prev.faq, status: !prev.faq.status, } }))}
                />
              }
              label={formData?.faq?.status ? "Visible" : "Hidden"}
            />          </Box>
        </AccordionSummary>
        <AccordionDetails>
          {
            formData?.faq?.section?.length > 0 ? <>
              {
                formData?.faq?.section?.map(((faq, idx) => {
                  return <Grid key={idx} item xs={12} sm={12} lg={12} my={2}>
                    <Box width={'100%'} className="faq-sec-rep">
                      <Box display='flex' flexDirection='column' justifyContent='space-between' alignItems={'flex-start'} className="mb-3">
                        <Box width={'100%'} display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                          <Typography variant="body2" fontWeight="medium" color="#2E2E3A">Question</Typography>
                          <MDButton
                            sx={{ minWidth: 'auto', p: 0 }}
                            size="small"
                            variant='text'
                            onClick={() => handleRemoveFAQ(idx)}
                            style={{ color: "#fd4438" }}
                          >
                            <DeleteIcon width="1rem" height="1rem" style={{ color: "#fd4438" }} />
                          </MDButton>
                        </Box>
                        <Box width={'100%'}>

                          <CommonQuillEditor
                            allowHeading={false}
                            allowImage={false}
                            value={faq?.question || ''}
                            onChange={(value) => handleChangeFAQ(value, 'question', idx)}
                          />
                          {Boolean(errors?.faq?.section[idx]?.question) && (
                            <FormHelperText error>{errors?.faq?.section[idx]?.question}</FormHelperText>
                          )}
                        </Box>
                      </Box>
                      <Box display='flex' justifyContent='center' alignItems={'flex-start'}>
                        <Box width={'100%'}>
                          <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Answer</Typography>
                          <CommonQuillEditor
                            allowHeading={false}
                            allowImage={false}
                            value={faq?.answer || ''}
                            onChange={(value) => handleChangeFAQ(value, 'answer', idx)}
                          />
                          {Boolean(errors?.faq?.section[idx]?.answer) && (
                            <FormHelperText error>{errors?.faq?.section[idx]?.answer}</FormHelperText>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Grid>;
                }))
              }
            </> : <Grid item xs={12} sm={12} lg={12} mt={3}>
              <Box display='flex' justifyContent='space-between' alignItems={'center'}>
                <MDButton
                  type='button'
                  color='primary'
                  size='medium'
                  variant='outlined'
                  sx={{ minWidth: '180px' }}
                  onClick={addFAQHandler}
                >
                  <Icon>add</Icon>&nbsp;Add FAQ
                </MDButton>
              </Box>
            </Grid>
          }

          {
            formData?.faq?.section?.length > 0 && <Grid item xs={12} mt={3}>
              <MDButton
                type='button'
                color='primary'
                size='medium'
                variant='outlined'
                sx={{ minWidth: '180px' }}
                onClick={addFAQHandler}
              >
                <Icon>add</Icon>&nbsp;Add More
              </MDButton>
            </Grid>
          }
        </AccordionDetails>
      </Accordion>

      {/********************** Save, Cancel Buttons **********************/}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2} mb={2}>
            <MDButton
              sx={{ minWidth: '160px' }}
              type='button'
              variant='contained'
              color='primary'
              onClick={handleSubmit}
              disabled={isLoading}
              isLoading={isLoading}
            >
              {fullRoleTabSlug ? 'Update' : 'Save'}
            </MDButton>
            {
              notSlug && <MDButton
                sx={{ minWidth: '160px', backgroundColor: '#fdd5d3', color: '#FD4438' }}
                type='button'
                variant='contained'
                color='error'
                onClick={() => {
                  dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: fullRoleTabHeading ,deleteType:"page" }, modal: 'DELETE_MODAL' }));
                }}
              >
                Delete
              </MDButton>
            }
            <MDButton
              sx={{ minWidth: '160px' }}
              type='button'
              variant='outlined'
              color='dark'
              onClick={() => navigate('/manages/static')}
            >
              Cancel
            </MDButton>
          </Stack>
        </Grid>
      </Grid>

    </Box>
  )
}

export default CareerPageEdit